import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import ViewUI from 'view-design';
import './assets/css/overwrite.less';
import './assets/css/base.less';
import './assets/theme/index.less';
import 'latex-render/index.css';
import lazyload from 'vue-lazyload';
import VueCookies from 'vue-cookies';
import md5 from 'js-md5';
import base64 from 'js-base64';
import { Drawer, Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import Directives from './directives/index'
Vue.use(Directives)
//import './mock'
Vue.use(Drawer);
Vue.prototype.$message = Message;
Vue.use(ViewUI);

Vue.use(lazyload, {
  error: '/img/lazy-404.jpg',
  loading: '/img/lazy-loading.png',
});
Vue.use(VueCookies);
Vue.prototype.$md5 = md5;
// Vue.prototype.$base64 = require('js-base64').Base64;
Vue.prototype.$base64 = base64.Base64;

// 定制机构IDS（用于教务定制）
Vue.prototype.$customIds = [
  4688, 6345, 6352, 6382, 6401, 6459, 6497, 6575, 6574, 6591, 6592,
];

Vue.config.productionTip = false;

// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title;
//   }
//   next();
// })

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
